import { DataValue } from '@cxbox-ui/core'

export const isEmptyValue = (value: DataValue) => value === '' || value === null || value === undefined
